import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject, of} from "rxjs";
import { throwError } from 'rxjs/internal/observable/throwError';
import {catchError, finalize} from "rxjs/operators";
import { TemplateService } from './template.service';

@Injectable({
    providedIn: 'root'
  })
export class TemplateDataSource implements DataSource<ModelEventiCalamitosi.TemplateDto> {

    private templateSubject = new BehaviorSubject<ModelEventiCalamitosi.TemplateDto[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    private errorSubject = new BehaviorSubject<boolean>(false);
    public errors$ = this.errorSubject.asObservable();
    isLoading: boolean = false;
    errorMessage: string = null;

    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();

    constructor(private templateService: TemplateService) {
    }

    loadTemplates(ipa:string,
                filter: ModelEventiCalamitosi.TemplateSearchableDto,
                sortDirection:string,
                pageIndex:number,
                pageSize:number) {

        this.loadingSubject.next(true);

        this.templateService.getList(pageIndex, pageSize, sortDirection, {
            idEvento: filter.idEvento,
            idTemplate: filter.idTemplate,
            tpModulo: filter.tpModulo,
            flDistribuito: filter.flDistribuito,
            descrizione: filter.descrizione
          }).pipe(
            catchError(err => {
              this.errorSubject.next(true);
              return throwError(err);
            }),
            catchError(err => {
              return of([]);
            }),
            finalize(() => this.loadingSubject.next(false))
        )
        .subscribe(result => {
            this.templateSubject.next(result['content']);
            this.countSubject.next(result['totalElements']);
        });
    }

    loadTemplatesForImport(ipa:string,
      filter: ModelEventiCalamitosi.TemplateImportSearchableDto,
      sortDirection:string,
      pageIndex:number,
      pageSize:number) {

this.loadingSubject.next(true);

this.templateService.getListForImport(pageIndex, pageSize, sortDirection, {
  idEvento: filter.idEvento,
  idTemplate: filter.idTemplate,
  tpModulo: filter.tpModulo,
  descrizioneEvento:filter.descrizioneEvento,
  descrizioneTemplate:filter.descrizioneTemplate

}).pipe(
  catchError(err => {
    this.errorSubject.next(true);
    return throwError(err);
  }),
  catchError(err => {
    return of([]);
  }),
  finalize(() => this.loadingSubject.next(false))
)
.subscribe(result => {
  this.templateSubject.next(result['content']);
  this.countSubject.next(result['totalElements']);
});
}

    connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.TemplateDto[]> {
        return this.templateSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.templateSubject.complete();
        this.loadingSubject.complete();
    }

}

